import { CommonRequestView } from '@/common/store/modules/common/types/CommonRequestView';

export const DEFAULT_REQUEST_VIEW = 'default';

export const addRequestView = (): CommonRequestView => ({
  list: [],
  count: null,
  loading: false,
  isLastPage: false,
  marker: undefined,
  requestParams: {}
});
